/**
 * Delegates to the browser's HTML parser so all named, numeric
 * and hex entities are decoded without maintaining a lookup map.
 *  */
export function decodeHtmlEntities(value: string): string {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = value;
  return textarea.value;
}
